import { graphql, useStaticQuery } from 'gatsby';
import { HeaderQueryProps, StrapiHeader } from 'typings';
import { selectLocalizedData } from '../utils/selectLocalizedData';

const headerQuery = graphql`
  query StrapiHeaderQuery {
    allStrapiHeader {
      nodes {
        login
        logoLabel
        logout
        signUp
        signUpUrl
        templates
        dashboards
        home
        search
        locale
        localizations {
          login
          logoLabel
          logout
          signUp
          signUpUrl
          templates
          dashboards
          home
          search
          locale
        }
      }
    }
  }
`;

export const useStrapiHeader = (locale?: string): StrapiHeader => {
  const { allStrapiHeader } = useStaticQuery<HeaderQueryProps>(headerQuery);

  const defaultHeader = allStrapiHeader.nodes[0];
  return selectLocalizedData(defaultHeader, locale);
};
